import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { ScheduleQueueSearchModel } from "src/app/core/models/schedule-queue-model";
import { ScheduleQueueService } from "src/app/core/services/schedule-services";
import { ScheduleQueueGridService } from "../shared/schedule-queue-grid-service";
import { ScheduleQueueMapperService } from "../shared/schedule-queue-mapper.service";
import { DateConverterService } from "src/app/core/utils/date-converter.service";

@Component({
    selector: 'op-schedule-queue-reaccom-task-table',
    templateUrl: './schedule-queue-reaccom-task-table.component.html',

})
export class ScheduleQueueReaccomTaskTableComponent implements OnInit {
    private readonly ACTION_CODE_CANCEL = "INVOLCANCELSERVICE";

    public scheduleQueueTaskData: any;

    @Input() parentScheduleQueueId: string;
    @Input() isCancelReacc: boolean = false;

    constructor(private changeDetectorRef: ChangeDetectorRef,
        private dateConverterService: DateConverterService,
        private scheduleQueueService: ScheduleQueueService,
        private scheduleQueueMapperService: ScheduleQueueMapperService,
        private scheduleQueueGridService: ScheduleQueueGridService) {
    }

    ngOnInit(): void {
        this.getData();
    }

    private getData() {
        if (this.parentScheduleQueueId) {
            this.scheduleQueueService.getChildren(this.parentScheduleQueueId)
                .subscribe(
                    (responses: ScheduleQueueSearchModel[]) => {
                        this.bindData(responses);
                    });
        }
    }

    private bindData(tasks: ScheduleQueueSearchModel[]) {
        if (!tasks?.length) {
            return;
        }

        if (this.isCancelReacc) {
            tasks = tasks.filter(x => x.scheduleQueueActionCode == this.ACTION_CODE_CANCEL);
        }
        this.scheduleQueueTaskData = this.scheduleQueueMapperService.bindTaskData(tasks);
        this.changeDetectorRef.detectChanges();
    }

    cellPrepared(e) {
        if (e.rowType != 'data') {
            return;
        }
        if (e.column.dataField == 'result') {
            this.scheduleQueueGridService.setResultCellColor(e);
        }
        this.removeExpand(e);
    }

    private noTotalOrder(e: any): boolean {
        return (e?.data?.numberOfOrders ?? 0) == 0;
    }

    private removeExpand(e) {
        if (e.rowType === "data" && e.column.command === "expand" && this.noTotalOrder(e)) {
            e.cellElement.removeClass("dx-datagrid-expand");
            e.cellElement.empty();
        }
    }

    protected formatDateTime(value: any) {
        return this.dateConverterService.formatSystemDateTime(value);
    }
}